export const slugify = (text: string): string => text
  .toString()          // Cast to string (optional)
  .normalize('NFKD')  // The normalize() using NFKD method returns the Unicode Normalization Form of a given string.
  .toLowerCase()      // Convert the string to lowercase letters
  .trim()             // Remove whitespace from both sides of a string (optional)
  .replace(/\s+/g, '-')       // Replace spaces with -
  .replace(/[^\w\-]+/g, '')   // Remove all non-word chars
  .replace(/\-\-+/g, '-')     // Replace multiple - with single -


export const parseSearchParams = (searchParams: string): Record<string, string[]> => {
  return searchParams.split('&').reduce((acc, param) => {
    const [key, values] = param.split('=')
    if (!key || !values) return acc

    const decodedValues = decodeURIComponent(values).split(',')

    // If key already exists, merge values
    acc[key] = acc[key] ? [...acc[key], ...decodedValues] : decodedValues

    return acc
  }, {} as Record<string, string[]>)
}

